import React from 'react';
import {
    IconSun, IconSoil, IconHeight, IconCalendar, IconFlower
} from '../ui/Icons';
import { formatDimension, getLocalizedValue } from '../../utils/plantFormatting';

const AttributeCard = ({ icon: Icon, label, value, colorClass = "text-plantlix-600 bg-plantlix-50 dark:bg-plantlix-900/20 dark:text-plantlix-400" }) => {
    if (!value) return null;
    return (
        <div className="flex items-start gap-3 p-3 rounded-xl bg-gray-50 dark:bg-white/5 border border-gray-100 dark:border-white/10">
            <div className={`p-2.5 rounded-lg ${colorClass} shrink-0`}>
                <Icon className="w-5 h-5" />
            </div>
            <div>
                <div className="text-xs font-semibold uppercase tracking-wider text-gray-400 dark:text-gray-500 mb-0.5">
                    {label}
                </div>
                <div className="text-sm font-medium text-gray-900 dark:text-gray-100 leading-snug">
                    {value}
                </div>
            </div>
        </div>
    );
};

const PlantAttributeGrid = ({ plant }) => {
    const heightDisplay = () => {
        if (plant.height_min_cm || plant.height_max_cm) {
            const min = plant.height_min_cm ? formatDimension(plant.height_min_cm) : null;
            const max = plant.height_max_cm ? formatDimension(plant.height_max_cm) : null;
            if (min && max) return `${min} - ${max}`;
            return max || min;
        }
        return plant.height;
    };

    return (
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-6">
            <AttributeCard
                icon={IconHeight}
                label="Wuchshöhe"
                value={heightDisplay()}
                colorClass="text-blue-600 bg-blue-50 dark:bg-blue-900/20 dark:text-blue-400"
            />
            <AttributeCard
                icon={IconCalendar}
                label="Blütezeit"
                value={plant.flowering_time || plant.flowering_months}
                colorClass="text-pink-600 bg-pink-50 dark:bg-pink-900/20 dark:text-pink-400"
            />
            <AttributeCard
                icon={IconFlower}
                label="Blütenfarbe"
                value={getLocalizedValue(plant, 'flower_color')}
                colorClass="text-purple-600 bg-purple-50 dark:bg-purple-900/20 dark:text-purple-400"
            />
            <AttributeCard
                icon={IconSun}
                label="Standort"
                value={getLocalizedValue(plant, 'location_preference') || plant.location}
                colorClass="text-amber-600 bg-amber-50 dark:bg-amber-900/20 dark:text-amber-400"
            />
            <AttributeCard
                icon={IconSoil}
                label="Boden"
                value={getLocalizedValue(plant, 'soil_type') || plant.soil}
                colorClass="text-stone-600 bg-stone-50 dark:bg-stone-900/20 dark:text-stone-400"
            />
            <AttributeCard
                icon={IconSoil}
                label="Wasserbedarf"
                value={plant.watering_needs}
                colorClass="text-cyan-600 bg-cyan-50 dark:bg-cyan-900/20 dark:text-cyan-400"
            />
            <AttributeCard
                icon={IconSun}
                label="Winterhärte"
                value={getLocalizedValue(plant, 'winter_hardiness')}
                colorClass="text-indigo-600 bg-indigo-50 dark:bg-indigo-900/20 dark:text-indigo-400"
            />
        </div>
    );
};

export default PlantAttributeGrid;
